import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchHolidaysSuccess = holidays => ({
  type: actions.FETCH_HOLIDAYS_SUCCESS,
  holidays,
});

export const fetchHolidays = (startDate, endDate) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .get(`/holidaysCompany/from/v2/${startDate}/to/${endDate}`)
    .then((response) => {
      dispatch(fetchHolidaysSuccess(response.data));
      dispatch(setLoading(false));
      return Promise.resolve();
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject();
    });
};

export const createHolidaySuccess = holiday => ({
  type: actions.CREATE_HOLIDAY_SUCCESS,
  holiday,
});

export const createHoliday = holiday => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/holidaysCompany/lot', holiday)
    .then((response) => {
      dispatch(createHolidaySuccess(response.data));
      dispatch(setLoading(false));
      dispatch(setMessage('Feriado cadastrado com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const deleteHolidaySuccess = id => ({
  type: actions.DELETE_HOLIDAY_SUCCESS,
  id,
});

export const deleteHoliday = (id, dtRemoval, isNational, originalRemoval) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .delete(`/holidaysCompany/v2/${id}?dtRemoval=${dtRemoval}&&isNational=${isNational}&&originalRemoval=${originalRemoval}`)
    .then(() => {
      dispatch(deleteHolidaySuccess(id));
      dispatch(setLoading(false));
      dispatch(setMessage('Feriado excluído com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};
